import { pageTitle } from '@shared/lib/page-title'
import { useEffect } from 'react'
import { useLocation } from 'react-router'

/** Mantém o título da aba coerente com a tela aberta. Montado uma vez em cada layout. */
export function usePageTitle() {
  const { pathname } = useLocation()
  useEffect(() => {
    document.title = pageTitle(pathname)
  }, [pathname])
}
